import { type ForwardedRef, forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'

import type { BaseTemplateInputHandle } from './BaseTemplateInput/BaseTemplateInput'
import WrappedBaseTemplateInput, {
  type WrappedBaseTemplateInputProps,
} from './WrappedBaseTemplateInput'

const useStyles = makeStyles(
  (theme) => ({
    title: {
      marginBottom: theme.spacing(1),
    },
    titleContainer: {
      margin: 0,
    },
  }),
  { name: 'CommunicationTemplateInput' },
)

export interface CommunicationTemplateInputProps
  extends Omit<
    WrappedBaseTemplateInputProps,
    | 'filter'
    | 'attachmentButtonRef'
    | 'files'
    | 'onAttachClick'
    | 'onAttachDocuments'
    | 'onDeleteFile'
    | 'showAttachment'
  > {}

const CommunicationTemplateInput = forwardRef(
  function CommunicationTemplateInput(
    { clientId, patientId, eventId, ...rest }: CommunicationTemplateInputProps,
    ref: ForwardedRef<BaseTemplateInputHandle>,
  ) {
    const classes = useStyles()
    const { t } = useTranslation(['Common'])

    return (
      <WrappedBaseTemplateInput
        classes={{
          title: classes.title,
          titleContainer: classes.titleContainer,
        }}
        clientId={clientId}
        eventId={eventId}
        filter={['Communication template']}
        label={t('Common:COMMUNICATION_TEMPLATE')}
        patientId={patientId}
        ref={ref}
        {...rest}
      />
    )
  },
)

export default CommunicationTemplateInput
